var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.011 12.459C46.4577 10.4027 44.8365 8.78185 42.7806 8.22815C39.0244 7.2002 23.9995 7.2002 23.9995 7.2002C23.9995 7.2002 8.97506 7.2002 5.21885 8.18896C3.2025 8.7423 1.54174 10.4031 0.988399 12.459C0 16.2148 0 24.0041 0 24.0041C0 24.0041 0 31.8325 0.988399 35.5492C1.54211 37.6051 3.16295 39.2263 5.21922 39.78C9.01461 40.808 23.9999 40.808 23.9999 40.808C23.9999 40.808 39.0244 40.808 42.7806 39.8192C44.8368 39.2659 46.4577 37.6446 47.0114 35.5887C47.9998 31.8325 47.9998 24.0436 47.9998 24.0436C47.9998 24.0436 48.0394 16.2148 47.011 12.459Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2168 31.2002L31.7108 24.0042L19.2168 16.8081V31.2002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubePlay);
export default __webpack_public_path__ + "static/media/youtube-play.b24373504931a586c03d95334e9f2292.svg";
export { ForwardRef as ReactComponent };